import { Navigate, useLocation } from 'react-router-dom';
import { useAppSelector, selectIsAuthenticated, useGetMeQuery } from '@nimbazaar/store';

interface ProtectedRouteProps {
  children: React.ReactNode;
}

export function ProtectedRoute({ children }: ProtectedRouteProps) {
  const isAuthenticated = useAppSelector(selectIsAuthenticated);
  const location = useLocation();

  // Keep wallet and user data in sync with the server.
  // This creates an active RTK Query subscription so when any mutation
  // invalidates the 'User' tag (e.g. createAd), getMe auto-refetches
  // and the wallet balance updates in real time.
  useGetMeQuery(undefined, { skip: !isAuthenticated });

  if (!isAuthenticated) {
    // Redirect to home with state to open auth modal
    return <Navigate to="/" state={{ openAuth: true, from: location }} replace />;
  }

  return <>{children}</>;
}
